export default __webpack_public_path__ + "static/media/G0680.34I-26416_-16236_0.1666267140000.d7c056d8.jpg";